import { render, staticRenderFns } from "./ConfirmResumableChat.vue?vue&type=template&id=754d9ed0&scoped=true"
import script from "./ConfirmResumableChat.vue?vue&type=script&lang=ts"
export * from "./ConfirmResumableChat.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmResumableChat.vue?vue&type=style&index=0&id=754d9ed0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754d9ed0",
  null
  
)

export default component.exports